<template>
  <div class="jimi-rule">
    <img class="banner" src="../../assets/img/基米总额@2x.png" />
    <div class="info-item" v-for="(item, index) in infoList" :key="index">
      <div class="title">
        <span class="index">{{ index + 1 }}.</span> {{ item.title }}
      </div>
      <div class="content">
        {{ item.content }}
      </div>
      <div class="explain" v-if="item.explain">
        <template v-for="(explain, index) in item.explain">
          <div class="subtitle" :key="index">
            {{ explain.title }}
          </div>
          <ul class="content" :key="index">
            <li v-for="text in explain.content" :key="text">
              {{ text }}
            </li>
          </ul></template
        >
      </div>
    </div>
    <div class="footer">
      <div class="text">
        风险提示：基金有风险，投资需谨慎，鹏扬基金管理有限公司对以上内容具有解释权。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'jimi-rule',
  data () {
    return {
      infoList: [
        { title: '基米定义', content: '基米是鹏扬APP为答谢广大客户长期支持而推出的一项感恩客户服务。收集基米将有机会享受附加服务、兑换多重权益和奖励。' },
        {
          title: '获取方法',
          content: '获取基米的方式多样，主要分为邀请奖励和平台奖励。您可通过体验好基通的各种功能（如注册、邀请好友、做任务、分享）等方式获取基米，详情请见具体页面的任务说明。',
          explain: [
            {
              title: '邀请奖励',
              content: [
                '每邀请一个新用户注册，您和好友都可以获得5个基米。',
                '您邀请的好友完成实名认证后，对方获得10个基米，您获得20个基米。'
              ]
            },
            {
              title: '平台奖励',
              content: [
                '完成平台任务、参与活动可获得基米，后续将推出更多基米玩法和活动，敬请期待。'
              ]
            }
          ]
        },
        { title: '使用场景', content: '基米可以用于多种情景：可以抵扣相关买入（申购）费用（具体以页面展示为准）、赠送好友。平台后续将提供更多的基米使用途径，如兑换奖品、服务等，敬请期待。' },
        { title: '查看方法', content: '您可通过“我的-我的邀请”查看基米。' },
        { title: '有效期限', content: '从获取基米当年开始，基米两年内有效。基米采用年初清算的方式，每年的1月1日0时清除两年前获得的未使用的基米。基米使用采取先进先出的原则， 比如您2021年获取的基米，将在2023年1月1日0点清除。' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.jimi-rule {
  width: 100vw;
  // height: 100vh;
  background-color: #fff;
  padding-top: 0.266rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  .banner {
    width: 9.15rem;
    height: 2.4rem;
    margin-bottom: 0.533rem;
    // height: 15rem;
  }
  .info-item {
    width: 8.933rem;
    font-size: 0.373rem;
    margin-bottom: 0.666rem;
    .title {
      font-weight: bold;
      font-size: 0.426rem;
      position: relative;
      .index {
        font-style: italic;
        margin-right: 0.106rem;
      }
      &::after {
        content: ' ';
        position: absolute;
        bottom: 0.05rem;
        left: 0;
        width: 1.76rem;
        height: 0.16rem;
        background-image: linear-gradient(
          270deg,
          rgba(142, 50, 254, 0) 0%,
          rgba(139, 50, 254, 0.36) 100%
        );
      }
    }
    .content {
      margin-top: 0.133rem;
      color: #666666;
      line-height: 0.56rem;
    }
    .explain {
      margin-top: 0.4rem;
      background: #f7f7f7;
      border-radius: 0.213rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.533rem 0.4rem;
      .subtitle {
        width: 100%;
        font-size: 0.4rem;
        color: #ef3c34;
        line-height: 0.586rem;
        font-weight: bold;
        margin-top: 0.533rem;
        &:first-child {
          margin-top: 0;
        }
      }
      .content {
        font-size: 0.373rem;
        color: #333333;
        line-height: 0.56rem;
        li {
          list-style: inside;
          margin-top: 0.266rem;
        }
      }
    }
  }
  .footer {
    height: 2.56rem;
    width: 100%;
    background: #f7f7f7;
    padding-top: 0.533rem;
    display: flex;
    justify-content: center;
    .text {
      width: 8.933rem;
      font-size: 0.32rem;
      color: #adadad;
      line-height: 0.48rem;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/JimiRule.vue